module.exports = __webpack_public_path__ + "static/media/md.27d6ff01.svg";